import { render } from "./grid-legend-container.vue?vue&type=template&id=6afc0a0d&scoped=true&ts=true"
import script from "./grid-legend-container.vue?vue&type=script&lang=ts"
export * from "./grid-legend-container.vue?vue&type=script&lang=ts"

import "./grid-legend-container.vue?vue&type=style&index=0&id=6afc0a0d&lang=scss"
import "./grid-legend-container.vue?vue&type=style&index=1&id=6afc0a0d&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6afc0a0d"]])

export default __exports__